import CloseIcon from 'assets/images/closeIcon.svg?react';
import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ScrollContainer from 'react-indiana-drag-scroll';
import { TRACKER_TABS } from 'shared/constants/common';
import { useScrollToTab } from 'shared/hooks/useScrollToTab';
import { LiveDetails } from '../../eventLive/interface/interface';
import { EventState, GamesState } from '../interface/sportPrematch';
import SearchBar from './SearchBar';

type NavigationTabsProps = {
	marketTypes: string[];
	eventDetailData: EventState | LiveDetails;
	setFilteredList: Dispatch<SetStateAction<GamesState[]>>;
	activePillTab: string;
	changeCurrentTab: (activePillTab: string) => void;
	isFootball?: boolean;
	filteredGames?: any;
	setFilteredGames?: any;
	groupedEvents?: any;
	isSearchBar?: boolean;
};

const NavigationTabs = ({
	marketTypes,
	eventDetailData,
	setFilteredList,
	activePillTab,
	changeCurrentTab,
	isFootball,
	filteredGames,
	setFilteredGames,
	groupedEvents,
	isSearchBar = true,
}: NavigationTabsProps) => {
	const { t } = useTranslation();
	const [isExpanded, setIsExpanded] = useState(false);
	const [value, setValue] = useState<string>('');
	const { scrollContainerRef, tabRefs, scrollToTab } = useScrollToTab({ useOffset: false });

	const handlePillClick = (tab: string, index: any) => {
		setIsExpanded(false);
		setValue('');
		setFilteredList([]);
		activePillTab !== tab ? changeCurrentTab(tab) : changeCurrentTab('All');
		scrollToTab(index);
	};

	const marketTypesWithoutBetBuilder = marketTypes.filter((item) => item !== TRACKER_TABS.BET_BUILDER);
	return (
		<ScrollContainer className="tabs_wrapper" ref={scrollContainerRef}>
			<div className="tabs_pill">
				<div className="tab">
					{isSearchBar && (
						<SearchBar
							eventDetailData={eventDetailData}
							setFilteredList={setFilteredList}
							isExpanded={isExpanded}
							isFootball={isFootball}
							setIsExpanded={setIsExpanded}
							value={value}
							setValue={setValue}
							changeCurrentTab={changeCurrentTab}
							activePillTab={activePillTab}
							filteredGames={filteredGames}
							setFilteredGames={setFilteredGames}
							groupedEvents={groupedEvents}
						/>
					)}
				</div>
				{marketTypesWithoutBetBuilder.map(
					(tab: string, index: any) =>
						tab !== 'All' && (
							<div
								ref={(el) => (tabRefs.current[index] = el)}
								className={`tab text--center text--capitalize font--medium truncate--text ${activePillTab === tab ? 'active' : ''}`}
								onClick={() => handlePillClick(tab, index)}
								key={`marketTypes-navigation-${index}`}
							>
								<div dangerouslySetInnerHTML={{ __html: t(`marketType_${tab}`) }} />
								{activePillTab === tab && <CloseIcon onClick={() => changeCurrentTab('All')} />}
							</div>
						),
				)}
			</div>
		</ScrollContainer>
	);
};

export default NavigationTabs;
